<template>
  <staking-index />
</template>

<script>
import StakingIndex from "@/components/organisms/limited-sauna-staking/StakingIndex";

export default {
  name: "PagesSaunaStaking",
  components: {
    StakingIndex,
  },
};
</script>
